import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import Small from 'UIComponents/elements/Small';
import UIImage from 'UIComponents/image/UIImage';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { SUITE_INTERSTITIAL } from '../../constants/pricing/DiscountedKeys';
import { SUITE_CARD } from '../../constants/tracking/Locations';
import { isAnyStarterGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import SuiteTileCTAsContainer from './SuiteTileCTAsContainer';
import { CrmSuitePrice } from './price-display/CrmSuitePrice';
export const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "SuiteStarterCard__StyledCardWrapper",
  componentId: "sc-1aercna-0"
})(["padding:48px 24px 32px 24px;margin-bottom:16px;"]);
export const StyledBlob = styled(UIImage).withConfig({
  displayName: "SuiteStarterCard__StyledBlob",
  componentId: "sc-1aercna-1"
})(["position:absolute;top:0;right:0;width:180px;"]);
const Container = styled.div.withConfig({
  displayName: "SuiteStarterCard__Container",
  componentId: "sc-1aercna-2"
})(["max-width:312px;margin-top:32px;"]);

const SuiteStarterCard = () => {
  const productLevel = STARTER;
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isStarterGWP = useSelector(isAnyStarterGWP2023EligibleSelector);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "p-bottom-4",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPricingAndPurchasingSucceeded,
          heights: [16, 23, 16],
          widths: [60, 70, 130],
          className: "flex-column",
          Content: CrmSuitePrice,
          contentProps: {
            productLevel,
            useDiscountedKey: SUITE_INTERSTITIAL,
            termOverride: ANNUAL
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-top-7",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPricingAndPurchasingSucceeded,
          heights: [47],
          children: /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
            productLevel: productLevel,
            trackingSource: SUITE_CARD,
            ctaStyles: {
              width: '100%',
              lineHeight: '23px'
            },
            returnFirstCTAOnly: true,
            isFreeToStarter: true
          })
        })
      })]
    }), isStarterGWP && /*#__PURE__*/_jsx(Small, {
      use: "help",
      className: "align-end p-right-6 p-bottom-8",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.promotions.starterGWPDisclaimer"
      })
    })]
  });
};

export default SuiteStarterCard;